'use client';

import type { ReactNode } from 'react';

import { captureError } from '../../../shared/utils/sentry';
import { Component } from 'react';

import { GlobalErrorContent } from './GlobalErrorContent';

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
};

type State = {
  hasError: boolean;
  error?: Error;
};

export class MarkdownErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('Markdown rendering error:', error, errorInfo);

    captureError(error, {
      component: 'MarkdownErrorBoundary',
      action: 'componentDidCatch',
      additionalData: {
        componentStack: errorInfo.componentStack,
      },
    });
  }

  override render(): ReactNode {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return <GlobalErrorContent error={this.state.error} showActions={false} />;
    }

    return this.props.children;
  }
}
